import { render, staticRenderFns } from "./PublicAffairsApp.vue?vue&type=template&id=3f1e04d4&"
import script from "./PublicAffairsApp.vue?vue&type=script&lang=js&"
export * from "./PublicAffairsApp.vue?vue&type=script&lang=js&"
import style0 from "./PublicAffairsApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports